import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

import ReactTable from 'react-table';

import styled from 'styled-components';
import { LinkButton } from 'modules/list';
import { Link } from 'react-router-dom';

import { OPTIONS } from 'constants/form';
import FilterDropdown from 'comps/filter/filter-dropdown';
import { getOptions } from 'modules/form';

import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';
import { FORM_ACTIONS } from 'constants/form';
import { TABLE_TYPE } from 'constants/list';
import { epochToDate, capitalizeFirstLetter } from 'utils';

import COLORS from 'constants/colors';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 8px;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

export const demoOptions = [
  {
    label: 'True',
    value: true,
  },
  {
    label: 'False',
    value: false,
  },
];

const TOGGLE_NOT_ALLOW_DEMO_STATE = ['CANCELLED', 'REQUESTED'];

class StudentDemoList extends PureComponent {
  onFilteredChange = filters => {
    this.props.onFilter(filters);
  };

  getTableRowProps = (state, rowInfo, instance) => {
    const { tableType } = this.props;

    if (!rowInfo || tableType === TABLE_TYPE.student) {
      return {};
    }
    return {
      style: {
        backgroundColor: rowInfo.original.source === 'TEACHER' ? COLORS.HAWKESBLUE : null,
        border: '4px solid white',
      },
    };
  };

  render() {
    const {
      isPlusLead,
      tableData,
      userConfig,
      onUpdateDemo,
      onToggleRMCall,
      programs,
      tableType,
      defaultPageSize,
      style,
    } = this.props;

    let pageSize = defaultPageSize ? defaultPageSize : 20;

    let gradeOptions = [];
    let stateOptions = [];
    let demoStateOptions = [];
    let demoLeadStateOptions = [];
    let sourceOptions = [];

    if (userConfig && programs) {
      gradeOptions = getOptions({ field: 'grade', userConfig, programs });
      stateOptions = getOptions({ field: 'studentState', userConfig, programs });
      demoStateOptions = getOptions({
        field: OPTIONS.STUDENT_DEMO_STATE,
        userConfig,
        programs,
      });
      demoLeadStateOptions = getOptions({
        field: OPTIONS.STUDENT_DEMO_LEAD_STATE,
        userConfig,
        programs,
      });
      sourceOptions = getOptions({
        field: OPTIONS.PARENT_SOURCE,
        userConfig,
        programs,
      });
    }

    const tableColumns = [
      {
        Header: tableType === TABLE_TYPE.student ? `Students` : `Rows`,
        columns: [
          {
            Header: 'Demo created on',
            accessor: 'created_on',
            width: 200,
            Cell: ({ value }) => (value ? epochToDate(value, 'DD/MM/YYYY, LT') : ''),
          },
          {
            Header: 'Name',
            accessor: 'student_name',
            show: tableType === TABLE_TYPE.student,
            width: 200,
            Cell: row => {
              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/student-form-parent/${row.original.student_id}/true`,
                    state: {
                      formType: FORM_ACTIONS.VIEW,
                      student: row.original,
                    },
                  }}
                >
                  {row.original.student_name}
                </LinkNav>
              );
            },
          },
          {
            Header: 'Teacher',
            accessor: 'teacher_id',
            show: tableType === TABLE_TYPE.parent,
            width: 300,
            Cell: row => {
              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/users/teachers/${row.original.teacher_id}/`,
                  }}
                >
                  {row.original.teacher_name !== null &&
                  row.original.teacher_phone !== null ? (
                    <>
                      {row.original.teacher_name}
                      {' - '} {row.original.teacher_phone}
                    </>
                  ) : (
                    row.original.teacher_id
                  )}
                </LinkNav>
              );
            },
          },
          {
            Header: 'Demo start date & time',
            accessor: 'scheduled_start_time',
            width: 200,
            Cell: ({ value }) => (value ? epochToDate(value, 'DD/MM/YYYY, LT') : ''),
          },
          {
            Header: 'Demo end date & time',
            accessor: 'scheduled_end_time',
            width: 200,
            Cell: ({ value }) => (value ? epochToDate(value, 'DD/MM/YYYY, LT') : ''),
          },
          {
            Header: 'Update',
            accessor: 'update',
            show: tableType === TABLE_TYPE.parent,
            width: 160,
            Cell: row => {
              return (
                <LinkButton
                  text="Update demo"
                  onClick={() => onUpdateDemo(row.original)}
                />
              );
            },
          },
          {
            Header: 'Toggle RM Call',
            accessor: 'toggle_rm_call',
            show: false, // toggleRMEnabled && isPlusLead && tableType === TABLE_TYPE.parent,
            width: 160,
            Cell: row => {
              if (TOGGLE_NOT_ALLOW_DEMO_STATE.includes(row.original.demo_state)) {
                return 'Required schedule Class';
              }

              return (
                <LinkButton
                  text="Toggle RM Call"
                  onClick={() => onToggleRMCall(isPlusLead, row.original)}
                />
              );
            },
          },
          {
            Header: 'Demo Source',
            accessor: 'source',
            show: tableType === TABLE_TYPE.parent,
            width: 150,
            Cell: ({ value }) => `${capitalizeFirstLetter(value)}-led`,
          },
          {
            Header: 'Demo State',
            accessor: 'demo_state',
            width: 160,
            filterable: true,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={demoStateOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'Direct Demo Allocation',
            acessor: 'is_direct_demo_allotted',
            width: 160,
            Cell: row => {
              const { is_direct_demo_allotted: isDirectDemoAllotted = '' } = row.original;

              if (isDirectDemoAllotted) {
                return 'True';
              }
              return 'False';
            },
          },
          {
            Header: 'Auto Demo Allocation',
            acessor: 'demo_request_id',
            width: 160,
            Cell: row => {
              const { demo_request_id: demoRequestId = '' } = row.original;

              if (demoRequestId) {
                return 'True';
              }
              return 'False';
            },
          },
          {
            Header: 'Demo Feedback',
            accessor: 'recent_classroom_id',
            width: 160,
            Cell: row => {
              const { state, recent_classroom_id: recentClassroomId } =
                row.original || {};

              if (state === 'INTERESTED') {
                return null;
              }

              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/demo/${recentClassroomId}/`,
                  }}
                >
                  {recentClassroomId}
                </LinkNav>
              );
            },
          },
          {
            Header: 'Source',
            accessor: 'source',
            width: 160,
            filterable: true,
            show: tableType === TABLE_TYPE.student,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={sourceOptions}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            Header: 'Program Id',
            accessor: 'program_id',
            show: tableType === TABLE_TYPE.parent,
            width: 300,
          },
          {
            Header: 'Parent Service Id',
            accessor: 'parent_service_id',
            width: 300,
            show: tableType === TABLE_TYPE.student,
          },
          {
            Header: 'Recent schedule classroom',
            accessor: 'recent_schedule_teacher_classroom_id',
            width: 220,
            Cell: row => {
              const { recent_schedule_teacher_classroom_id: recentTeacherClassroomId } =
                row && row.original;

              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/users/teacher-classroom/${recentTeacherClassroomId}/`,
                  }}
                >
                  {recentTeacherClassroomId}
                </LinkNav>
              );
            },
            show: tableType === TABLE_TYPE.parent,
          },
        ],
      },
    ];

    return (
      <TableWrapper>
        <ReactTable
          data={tableData}
          className="-highlight"
          manual
          showPaginationTop
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          resizable={false}
          defaultPageSize={pageSize}
          style={style}
          onFilteredChange={this.onFilteredChange}
          defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
          columns={tableColumns}
          onPageChange={this.onPageChange}
          getTrProps={this.getTableRowProps}
        />
      </TableWrapper>
    );
  }
}

StudentDemoList.propTypes = {
  history: PropTypes.shape({}).isRequired,
  isPlusLead: PropTypes.bool,
  onToggleRMCall: PropTypes.func.isRequired,
};
StudentDemoList.defaultProps = {
  isPlusLead: false,
};

export default connect(
  ({ configs, programs }) => ({
    userConfig: store.get(configs, USER_CONFIG),
    batchConfig: store.get(configs, BATCHES_CONFIG),
    programs: store.getAll(programs),
  }),
  null,
)(StudentDemoList);
